import { render, staticRenderFns } from "./ClientEditTabPlanDetails.vue?vue&type=template&id=b05297b2&"
import script from "./ClientEditTabPlanDetails.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabPlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabPlanDetails.vue?vue&type=style&index=0&id=b05297b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports